<template>
  <div>
    <div class="p20  dis-f ai-c bg-c-fff">
      <div class="dis-f ai-c wp30">
        <div class="w50 h50 wp-rad50 bg-c-999 bor1-efefef"></div>
        <span class="p10 fs16 fw-b">您好，亮亮</span>
      </div>
      <span class="wp70 ta-r slogan">以学术关怀社会</span>
    </div>

    <!-- 左边 -->
    <div class="wp100 mt20 dis-f">
      <div class="wp70">
        <div class="mt10 bor1-efefef">
          <div class="bg-c-FAFAFC">
            <div class="rad10">
              <div class="wp100 dis-f fs14">
                <!-- card -->
                <div
                  class="p20 bor1-efefef m20 rad10 imgs"
                  style="flex: 1"
                  @click="gotolinkContribution"
                  v-on:mouseover="changeActive($event)"
                  v-on:mouseout="removeActive($event)"
                >
                  <img
                    src="../../../assets/imgs/1-1.png"
                    class="card-bg"
                    alt=""
                    srcset=""
                  />
                  <div class="">
                    <span class="sz sztougao fs30"></span>
                    <span class="fs16 pl10 fs30">投稿</span>
                    <div class="fs16 pt20">杂志投稿</div>
                  </div>
                </div>
                <div
                  class="p20 bor1-efefef m20 rad10 imgs"
                  style="flex: 1"
                  @click="gotolinkEssay"
                  v-on:mouseover="changeActive($event)"
                  v-on:mouseout="removeActive($event)"
                >
                  <img
                    src="../../../assets/imgs/1-2.png"
                    class="card-bg"
                    alt=""
                    srcset=""
                  />
                  <div class="">
                    <span class="sz szminyizhengji fs30"></span>
                    <span class="fs16 pl10 fs30">征文</span>
                    <div class="fs16 pt20">集团征文</div>
                  </div>
                </div>
                <div
                  class="p20 bor1-efefef m20 rad10 imgs"
                  style="flex: 1"
                  @click="gotolinkPeriodical"
                  v-on:mouseover="changeActive($event)"
                  v-on:mouseout="removeActive($event)"
                >
                  <img
                    src="../../../assets/imgs/1-3.png"
                    class="card-bg"
                    alt=""
                    srcset=""
                  />
                  <div class="">
                    <span class="sz szzazhiqikan fs30"></span>
                    <span class="fs16 pl10 fs30">科研期刊</span>
                    <div class="fs16 pt20">杂志期刊</div>
                  </div>
                </div>
                <div
                  class="p20 bor1-efefef m20 rad10 imgs"
                  style="flex: 1"
                  v-on:mouseover="changeActive($event)"
                  v-on:mouseout="removeActive($event)"
                >
                  <img
                    src="../../../assets/imgs/1-4.png"
                    class="card-bg"
                    alt=""
                    srcset=""
                  />
                  <div class="">
                    <span class="sz szgengduo fs30"></span>
                    <span class="fs16 pl10 fs30">更多</span>
                    <div class="fs16 pt20">暂无更多</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-tabs class="mt30" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="《上海教育科研》" name="first">
            <div class="dis-f fw-w ai-c jc-s mb10">
              <el-col :span="4" class="m20" v-for="magazine in magazine0List">
                <el-card shadow="hover" :body-style="{ padding: '0px' }">
                  <div class="bor1-b-efefef">
                    <el-image
                      style="width: 100%"
                      :src="`${basePicPath}${magazine.cover_img}`"
                      :fit="fit"
                    ></el-image>
                    <div class="p10 ta-c h90 bor1-t-e7e7eb">
                      {{ magazine.title }}
                    </div>
                  </div>
                </el-card>
              </el-col>
            </div>
          </el-tab-pane>
          <el-tab-pane label="《上海教育情报》" name="second">
            <div class="dis-f fw-w ai-c jc-s mb10">
              <el-col :span="4" class="m20" v-for="magazine in magazine1List">
                <el-card shadow="hover" :body-style="{ padding: '0px' }">
                  <div class="bor1-b-efefef">
                    <el-image
                      style="width: 100%"
                      :src="`${basePicPath}${magazine.cover_img}`"
                      :fit="fit"
                    ></el-image>
                    <div class="p10 ta-c h90 bor1-t-e7e7eb">
                      {{ magazine.title }}
                    </div>
                  </div>
                </el-card>
              </el-col>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 右边 -->
      <div class="wp30 pl10">
        <div class="mt10 bor1-efefef">
          <div class="pt20 pl20 fs16 fw-b">
            <span class="bor5-l-FF0000 pl10">我的管理</span>
          </div>
          <div class="p10">
            <div class="wp60 m0 fs14">
              <div
                class="p20 bor1-efefef m20 rad10 imgs"
                style="flex: 1"
                @click="gotolinkMyContribution"
                v-on:mouseover="changeActive($event)"
                v-on:mouseout="removeActive($event)"
              >
                <img
                  src="../../../assets/imgs/1-1.png"
                  class="card-bg"
                  alt=""
                  srcset=""
                />
                <div class="fs16">
                  <span class="sz sztougao fs30"></span>
                  <span class="pl10 fs30">我的投稿</span>
                  <div class="pt20">今日的投稿数：1</div>
                </div>
              </div>
              <div
                class="p20 bor1-efefef m20 rad10 imgs"
                style="flex: 1"
                @click="gotolinkMyEssay"
                v-on:mouseover="changeActive($event)"
                v-on:mouseout="removeActive($event)"
              >
                <img
                  src="../../../assets/imgs/1-2.png"
                  class="card-bg"
                  alt=""
                  srcset=""
                />
                <div class="">
                  <span class="sz szminyizhengji fs30"></span>
                  <span class="fs16 pl10 fs30">我的征文</span>
                  <div class="fs16 pt20">今日的征文数：1</div>
                </div>
              </div>
              <div
                class="p20 bor1-efefef m20 rad10 imgs"
                style="flex: 1"
                @click="gotolinkMyPeriodical"
                v-on:mouseover="changeActive($event)"
                v-on:mouseout="removeActive($event)"
              >
                <img
                  src="../../../assets/imgs/1-3.png"
                  class="card-bg"
                  alt=""
                  srcset=""
                />
                <div class="">
                  <span class="sz szzazhiqikan fs30"></span>
                  <span class="fs16 pl10 fs30">情报期刊</span>
                  <div class="fs16 pt20">杂志期刊</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p20 ta-c fs15">
      沪ICP备05026355 版权所有：上海市教育科学研究院 © 2021
      地址：上海市茶陵北路21号 邮政编码：200032
    </div>
  </div>
</template>

<script>
import global from "../../../../global";
export default {
  data() {
    return {
      basePicPath: "",
      fit: "cover",
      activeName: "first",
      magazine0List: [],
      magazine1List: [],
    };
  },
  methods: {
    //指定跳转地址
    gotolinkContribution() {
      this.$router.replace("/contribution");
    },
    gotolinkEssay() {
      this.$router.replace("/essay");
    },
    gotolinkPeriodical() {
      this.$router.replace("/periodical");
    },
    gotolinkMyContribution() {
      this.$router.push({ path: "/contribution?activeName=second" });
    },
    gotolinkMyEssay() {
      this.$router.push({ path: "/essay?activeName=second" });
    },
    gotolinkMyPeriodical() {
      this.$router.push({ path: "/periodical?activeName=second" });
    },
    //鼠标移入移出
    changeActive($event) {
      $event.currentTarget.className = "imgs active";
    },
    removeActive($event) {
      $event.currentTarget.className = "imgs";
    },

    handleClick() {},
  },
  mounted() {
    this.basePicPath = global.picUrl;

    this.$api.mall
      .index()
      .then((res) => {
        console.log(res, "首页");
        console.log(res.Data.magazine0List);
        this.magazine0List = res.Data.magazine0List;
        this.magazine1List = res.Data.magazine1List;
      })
      .catch((err) => {
        this.alertError(err.Data);
      });
  },
};
</script>

<style lang="scss" scoped>
.imgs {
  width: 100%;
  position: relative;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
}

.active {
  width: 100%;
  background-image: url("../../../assets/imgs/1-2.png");
  background: linear-gradient(to right, #365ac2, #527adf);
  position: relative;
  color: #fff;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
}
.imges {
  width: 100%;
  background-image: url("../../../assets/imgs/1-2.png");
  background: linear-gradient(to right, #365ac2, #527adf);
  position: relative;
  color: #fff;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
}

.card-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.slogan {
  font-size: 45px;
  color: #ee8707;
  font-family: STZhongsong;
  letter-spacing: 0.6em;
}
</style>
